import React, { useState } from 'react';
import { Alert, Button, Stack } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useNavigate, useParams } from 'react-router-dom';
import { AnimatedPage } from '../components/animations/MotionContainers';
import { EntradaForm } from '../components/entradas/EntradaForm';
import { useFlujosEntrada } from '../hooks/useFlujosEntradas';
import { updateFlujosEntrada } from '../services/apis';
import { flujosEditEnabled } from '../utils/flujosEditAvailability';
import { buildEntradaUpdatePayload } from '../utils/entradaEditing';

export const EditarEntrada = () => {
  const { codigo } = useParams();
  const navigate = useNavigate();
  const [reloadToken, setReloadToken] = useState(0);
  const { entrada, loading, error } = useFlujosEntrada(codigo, {}, reloadToken);

  const handleUpdate = async ({ payload, motivo, version }) => {
    if (!flujosEditEnabled) return;

    await updateFlujosEntrada(codigo, buildEntradaUpdatePayload(payload, version, motivo));
    navigate(`/consulta-entradas/${codigo}`);
  };

  if (loading || error || !entrada) {
    return (
      <AnimatedPage>
        <Stack spacing={2}>
          <Alert severity={error || !loading ? 'error' : 'info'} variant="outlined">
            {error || (loading ? 'Cargando entrada...' : 'No se ha encontrado la entrada.')}
          </Alert>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<ArrowBackRoundedIcon />}
            onClick={() => navigate(`/consulta-entradas/${codigo}`)}
            sx={{ alignSelf: 'flex-start' }}
          >
            Volver
          </Button>
        </Stack>
      </AnimatedPage>
    );
  }

  return (
    <EntradaForm
      initialEntrada={entrada}
      onBack={() => navigate(`/consulta-entradas/${codigo}`)}
      onReload={() => setReloadToken((current) => current + 1)}
      onUpdate={flujosEditEnabled ? handleUpdate : undefined}
    />
  );
};
